(() => {
  const COLOR_HEX = {
    tan: '#c4a574',
    'pigment tan': '#c4a574',
    'amber brown': '#5a3326',
    'dark brown': '#4a2d24',
    'chocolate brown': '#4a2d24',
    chocolate: '#4a2d24',
    coffee: '#6b4534',
    'coffee brown': '#6b4534',
    mocha: '#6b4534',
    'pigment black': '#1a1a1a',
    black: '#1a1a1a',
    'midnight black': '#1a1a1a',
    'charcoal black': '#1a1a1a',
    'coal black': '#1a1a1a',
    'storm grey': '#8a8d90',
    'storm gray': '#8a8d90',
    'slate grey': '#6d737a',
    'slate gray': '#6d737a',
    grey: '#8a8d90',
    gray: '#8a8d90',
    charcoal: '#4a4a4a',
    'charcoal gray': '#4a4a4a',
    'dark grey': '#4a4a4a',
    'dark gray': '#4a4a4a',
    'ash grey': '#b8b6b1',
    'ash gray': '#b8b6b1',
    'heather gray': '#b8b6b1',
    'light gray': '#b8b6b1',
    blue: '#3d6aa3',
    'somber blue': '#4d6270',
    navy: '#1f3358',
    'navy blue': '#1f3358',
    'baby blue': '#9bb8d4',
    'sapphire blue': '#2a4d8c',
    'lake blue': '#5a8fad',
    'pigment pink': '#e5b3c4',
    pink: '#e5b3c4',
    'light pink': '#f0c8cf',
    blush: '#f0c8cf',
    white: '#f4f2ee',
    'off white': '#f4f2ee',
    'pearl white': '#f4f2ee',
    evergreen: '#1f4a36',
    forest: '#1f4a36',
    'forest green': '#1f4a36',
    'dark green': '#1f4a36',
    'deep green': '#1f4a36',
    'alpine green': '#3f6b4e',
    mint: '#9ec9b0',
    cream: '#efe6d4',
    ivory: '#efe6d4',
    maroon: '#6e2c3a',
    burgundy: '#6b2d3c',
    purple: '#8f7dbe',
    lavender: '#8a6fa3',
    yellow: '#e6c86a',
    'mustard yellow': '#e6c86a',
    red: '#b42318',
    beige: '#d6c4a8',
    khaki: '#c4b18a',
    taupe: '#c4b18a',
    orange: '#d46a2a',
    green: '#3d6b4a',
  };

  const resolveColor = (name) => {
    const key = (name || '').toLowerCase().trim();
    if (COLOR_HEX[key]) return COLOR_HEX[key];
    if (/black|coal/.test(key)) return '#1a1a1a';
    if (/white|ivory|pearl/.test(key)) return '#f4f2ee';
    if (/cream/.test(key)) return '#efe6d4';
    if (/amber|brown|coffee|mocha|chocolate/.test(key)) return '#5a3326';
    if (/navy/.test(key)) return '#1f3358';
    if (/blue|somber/.test(key)) return '#4d6270';
    if (/evergreen|forest|alpine/.test(key)) return '#1f4a36';
    if (/green|olive|mint|sage/.test(key)) return '#3d6b4a';
    if (/pink|blush|peach/.test(key)) return '#e5b3c4';
    if (/purple|plum|grape|lavender/.test(key)) return '#8f7dbe';
    if (/red|maroon|burgundy|cherry|brick/.test(key)) return '#b42318';
    if (/yellow|gold|mustard|lemon/.test(key)) return '#e6c86a';
    if (/grey|gray|slate|storm|ash|charcoal/.test(key)) return '#8a8d90';
    if (/tan|khaki|beige|taupe|sand/.test(key)) return '#c4a574';
    if (/orange/.test(key)) return '#d46a2a';
    return '';
  };

  const VARIANT_TITLE = /^(color|colour|size|number of pets|no\.?\s*of pets)$/i;
  const TEXT_TITLE = /(name|text|monogram|personalise|personalize|include name)/i;
  const TITLE_SELECTOR = '.ymq-option-title, .ymq_lable, .ymq-lable, .ymq-title';

  const optionBoxes = () =>
    Array.from(document.querySelectorAll('.ymq-options-box, .ymq-option')).filter((box) => {
      return !box.closest('.cmb-upload-doc, .cmb-add-text-toggle, .cmb-ymq-select-wrap');
    });

  const titleNodeOf = (box) => box.querySelector(TITLE_SELECTOR);

  const titleOf = (box) => (titleNodeOf(box)?.textContent || '').replace(/\s+/g, ' ').trim();

  const hideDuplicateYmqVariants = () => {
    const picker = document.querySelector('variant-picker');
    const themeVisible = Boolean(picker && picker.querySelector('.variant-option') && picker.offsetParent !== null);
    if (!themeVisible) return;

    optionBoxes().forEach((box) => {
      if (box.dataset.cmbVariantHidden === '1') return;
      const title = titleOf(box);
      if (!title || !VARIANT_TITLE.test(title)) return;
      box.classList.add('cmb-hide-ymq-variant');
      box.dataset.cmbVariantHidden = '1';
    });
  };

  const paintYmqColors = () => {
    optionBoxes().forEach((box) => {
      const title = titleOf(box);
      if (!title || !/^(color|colour)$/i.test(title)) return;
      if (box.classList.contains('cmb-hide-ymq-variant')) return;

      box.classList.add('cmb-ymq-color');
      box.querySelectorAll('label').forEach((label) => {
        if (label.dataset.cmbSwatch === '1') return;
        const name = (label.textContent || label.getAttribute('title') || '').trim();
        const hex = resolveColor(name);
        if (!hex) return;
        label.dataset.cmbSwatch = '1';
        label.style.background = hex;
        label.title = name;
      });
    });
  };

  const hideUploadChrome = (box, keep) => {
    Array.from(box.children).forEach((child) => {
      if (keep.includes(child)) return;
      if (child.matches(TITLE_SELECTOR)) return;
      child.hidden = true;
      child.setAttribute('aria-hidden', 'true');
      child.style.setProperty('display', 'none', 'important');
    });
  };

  const restyleUploads = () => {
    if (document.querySelector('[data-cmb-pet-photo]')) {
      optionBoxes().forEach((box) => {
        if (!box.querySelector('input[type="file"]')) return;
        box.classList.add('cmb-hide-ymq-variant');
        box.dataset.cmbVariantHidden = '1';
      });
      return;
    }

    optionBoxes().forEach((box) => {
      const input = box.querySelector('input[type="file"]');
      if (!input) return;

      box.classList.add('cmb-ymq-upload');
      const titleNode = titleNodeOf(box);
      if (titleNode) titleNode.textContent = 'Pet photo';

      let doc = box.querySelector(':scope > .cmb-upload-doc');
      if (!doc) {
        doc = document.createElement('label');
        doc.className = 'cmb-upload-doc';
        doc.innerHTML =
          '<span class="cmb-upload-doc__icon" aria-hidden="true"></span>' +
          '<span class="cmb-upload-doc__copy">' +
          '<span class="cmb-upload-doc__title">Upload a photo</span>' +
          '<span class="cmb-upload-doc__hint">JPG, PNG or HEIC. Front-facing, natural light.</span>' +
          '</span>';
        box.appendChild(doc);
        doc.appendChild(input);
        input.addEventListener('change', () => {
          const file = input.files && input.files[0];
          const title = doc.querySelector('.cmb-upload-doc__title');
          if (title) title.textContent = file ? file.name : 'Upload a photo';
        });
      }

      hideUploadChrome(box, [doc]);
      box.dataset.cmbUpload = '1';
    });
  };

  const wrapAddText = () => {
    optionBoxes().forEach((box) => {
      const field = box.querySelector('input[type="text"], textarea, input.ymq-input-text');
      if (!field) return;
      if (box.querySelector('input[type="file"]')) return;

      const title = titleOf(box) || (box.textContent || '');
      if (!TEXT_TITLE.test(title) || VARIANT_TITLE.test(titleOf(box))) return;

      box.classList.add('cmb-ymq-add-text');
      const titleNode = titleNodeOf(box);
      const extra = ((titleNode?.textContent || title).match(/\(\+?\s*\$[\d.]+\)/) || [])[0] || '';
      if (titleNode) titleNode.hidden = true;

      let toggle = box.querySelector(':scope > .cmb-add-text-toggle');
      let fieldWrap = box.querySelector(':scope > .cmb-add-text-field');

      if (!fieldWrap) {
        fieldWrap = document.createElement('div');
        fieldWrap.className = 'cmb-add-text-field';
        field.parentNode.insertBefore(fieldWrap, field);
        fieldWrap.appendChild(field);
      }

      if (!toggle) {
        toggle = document.createElement('label');
        toggle.className = 'cmb-add-text-toggle';
        toggle.innerHTML = `<input type="checkbox" class="cmb-add-text-checkbox"> <span>Add text${
          extra ? ` ${extra}` : ''
        }</span>`;
        fieldWrap.insertAdjacentElement('beforebegin', toggle);

        const checkbox = toggle.querySelector('input');
        const sync = () => {
          const on = checkbox.checked;
          fieldWrap.hidden = !on;
          if (!on) {
            field.value = '';
            field.dispatchEvent(new Event('input', { bubbles: true }));
            field.dispatchEvent(new Event('change', { bubbles: true }));
          }
        };
        checkbox.addEventListener('change', sync);
        checkbox.checked = Boolean(field.value && field.value.trim());
        sync();
      }

      box.dataset.cmbText = '1';
    });
  };

  const convertButtonGroups = () => {
    optionBoxes().forEach((box) => {
      if (box.dataset.cmbDropdown === '1') {
        box.querySelectorAll('.ymq-options-button-input + label, .ymq-options-button-input, input[type="radio"]').forEach((node) => {
          node.classList.add('cmb-ymq-native-hidden');
        });
        return;
      }
      if (box.classList.contains('cmb-hide-ymq-variant')) return;
      if (box.classList.contains('cmb-ymq-upload')) return;
      if (box.classList.contains('cmb-ymq-add-text')) return;
      if (box.classList.contains('cmb-ymq-color')) return;
      if (/^(color|colour)$/i.test(titleOf(box))) return;

      const radios = Array.from(box.querySelectorAll('.ymq-options-button-input, input[type="radio"]')).filter(
        (input) => input.type === 'radio' || input.classList.contains('ymq-options-button-input'),
      );
      if (radios.length < 2) return;

      const wrap = document.createElement('div');
      wrap.className = 'cmb-ymq-select-wrap';
      const select = document.createElement('select');
      select.className = 'cmb-ymq-select';
      select.setAttribute('aria-label', titleOf(box) || 'Option');

      const blank = document.createElement('option');
      blank.value = '';
      blank.textContent = 'Choose an option';
      select.appendChild(blank);

      radios.forEach((radio) => {
        const label = (radio.id && box.querySelector(`label[for="${CSS.escape(radio.id)}"]`)) || radio.nextElementSibling;
        const option = document.createElement('option');
        option.value = radio.id || radio.value;
        option.textContent = (label?.textContent || radio.value || '').replace(/\s+/g, ' ').trim();
        option.selected = Boolean(radio.checked);
        select.appendChild(option);
        radio.classList.add('cmb-ymq-native-hidden');
        if (label) label.classList.add('cmb-ymq-native-hidden');
      });

      if (!radios.some((radio) => radio.checked)) blank.selected = true;

      select.addEventListener('change', () => {
        const radio =
          document.getElementById(select.value) ||
          radios.find((item) => item.value === select.value || item.id === select.value);
        if (!radio) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('input', { bubbles: true }));
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        radio.click();
      });

      wrap.appendChild(select);
      box.appendChild(wrap);
      box.classList.add('cmb-ymq-dropdown');
      box.dataset.cmbDropdown = '1';
    });
  };

  const nativePhotoRoot = () => document.querySelector('[data-cmb-pet-photo]');

  const parsePetsCount = (value) => {
    const match = String(value || '').match(/(\d+)/);
    const n = match ? parseInt(match[1], 10) : 1;
    return Math.min(Math.max(n, 1), 4);
  };

  const currentPetsCount = () => {
    const picker = document.querySelector('variant-picker');
    if (!picker) return 1;
    const options = Array.from(picker.querySelectorAll('.variant-option'));
    for (const opt of options) {
      const label = (opt.textContent || '').toLowerCase();
      if (!label.includes('pet')) continue;
      const select = opt.querySelector('select');
      if (select) {
        const chosen = select.options[select.selectedIndex]?.text || select.value;
        return parsePetsCount(chosen);
      }
      const checked = opt.querySelector('input:checked');
      if (checked) return parsePetsCount(checked.value);
    }
    return 1;
  };

  const ymqFileInputs = () =>
    Array.from(document.querySelectorAll('.ymq-options-box input[type="file"], .ymq-option input[type="file"]'));

  const copyFileToInput = (fromInput, toInput) => {
    if (!fromInput || !toInput || typeof DataTransfer === 'undefined') return;
    const file = fromInput.files && fromInput.files[0];
    if (!file) return;
    try {
      const transfer = new DataTransfer();
      transfer.items.add(file);
      toInput.files = transfer.files;
      toInput.dispatchEvent(new Event('input', { bubbles: true }));
      toInput.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (error) {
      // Safari can block assigning FileList; native Shopify property still submits.
    }
  };

  const wirePhotoFormSubmission = (root) => {
    const firstInput = root.querySelector('input[type="file"]');
    const formId = firstInput?.getAttribute('form');
    const form = formId ? document.getElementById(formId) : firstInput?.closest('form');
    if (!form || form.dataset.cmbPhotoSubmitWired === '1') return;
    form.dataset.cmbPhotoSubmitWired = '1';

    const submitWithPhotos = async (event, submitter) => {
      const fileInputs = Array.from(root.querySelectorAll('input[type="file"]'));
      if (!fileInputs.some((input) => input.files && input.files.length > 0)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.cmbPhotoSubmitting === '1') return;
      form.dataset.cmbPhotoSubmitting = '1';

      try {
        if (submitter) {
          submitter.disabled = true;
          submitter.setAttribute('aria-busy', 'true');
        }

        const formData = new FormData(form);
        const cartAddUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'Photo upload failed.');
        }
        window.location.assign(window.Theme?.routes?.cart_url || '/cart');
      } catch (error) {
        delete form.dataset.cmbPhotoSubmitting;
        if (submitter) {
          submitter.disabled = false;
          submitter.removeAttribute('aria-busy');
        }
        window.alert(error?.message || 'We could not upload your photos. Please try again.');
      }
    };

    form.addEventListener(
      'click',
      (event) => {
        const submitter = event.target.closest?.('[type="submit"]');
        if (!submitter || !form.contains(submitter)) return;
        submitWithPhotos(event, submitter);
      },
      { capture: true },
    );

    form.addEventListener('submit', (event) => submitWithPhotos(event, event.submitter), { capture: true });
  };

  const syncExtraPhotoSlots = () => {
    const root = nativePhotoRoot();
    if (!root || root.getAttribute('data-cmb-extra-photos') !== 'true') return;
    root.querySelectorAll('[data-cmb-photo-slot]').forEach((slot) => {
      slot.hidden = false;
    });
  };

  const wireNativePhotos = () => {
    const root = nativePhotoRoot();
    if (!root) return;
    wirePhotoFormSubmission(root);
    if (root.dataset.cmbPhotoWired === '1') {
      root.querySelectorAll('[data-cmb-photo-slot]').forEach((slot) => {
        const input = slot.querySelector('input[type="file"]');
        const index = Number(slot.getAttribute('data-cmb-photo-slot')) - 1;
        if (input && input.files && input.files[0]) copyFileToInput(input, ymqFileInputs()[index]);
      });
      syncExtraPhotoSlots();
      return;
    }
    root.dataset.cmbPhotoWired = '1';

    root.querySelectorAll('[data-cmb-photo-slot]').forEach((slot) => {
      const input = slot.querySelector('input[type="file"]');
      const title = slot.querySelector('.cmb-upload-doc__title');
      const preview = slot.querySelector('.cmb-upload-doc__preview');
      const remove = slot.querySelector('.cmb-pet-photo__remove');
      if (!input || !title) return;
      title.dataset.cmbDefaultLabel = title.textContent;
      let previewUrl = '';

      const updatePreview = () => {
        const file = input.files && input.files[0];
        title.textContent = file ? file.name : title.dataset.cmbDefaultLabel;

        if (previewUrl) {
          URL.revokeObjectURL(previewUrl);
          previewUrl = '';
        }

        if (file && preview && remove) {
          previewUrl = URL.createObjectURL(file);
          preview.src = previewUrl;
          preview.alt = `Preview of ${file.name}`;
          preview.hidden = false;
          remove.hidden = false;
          slot.classList.add('cmb-pet-photo__slot--selected');
        } else {
          if (preview) {
            preview.removeAttribute('src');
            preview.alt = '';
            preview.hidden = true;
          }
          if (remove) remove.hidden = true;
          slot.classList.remove('cmb-pet-photo__slot--selected');
        }

        const index = Number(slot.getAttribute('data-cmb-photo-slot')) - 1;
        copyFileToInput(input, ymqFileInputs()[index]);
      };

      input.addEventListener('change', updatePreview);

      if (remove) {
        remove.addEventListener('click', () => {
          const index = Number(slot.getAttribute('data-cmb-photo-slot')) - 1;
          const ymqInput = ymqFileInputs()[index];
          input.value = '';
          if (ymqInput) {
            ymqInput.value = '';
            ymqInput.dispatchEvent(new Event('input', { bubbles: true }));
            ymqInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.focus();
        });
      }

      if (input.files && input.files[0]) updatePreview();
    });

    document.addEventListener('change', (event) => {
      if (event.target.closest && event.target.closest('variant-picker')) {
        syncExtraPhotoSlots();
      }
    });

    syncExtraPhotoSlots();
  };

  const enhance = () => {
    hideDuplicateYmqVariants();
    paintYmqColors();
    restyleUploads();
    wrapAddText();
    convertButtonGroups();
    wireNativePhotos();
  };

  let timer = 0;
  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(enhance, 80);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance, { once: true });
  } else {
    enhance();
  }

  const root = document.querySelector('main, #MainContent, body');
  if (root) {
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true });
  }
})();

